import { Component } from '@angular/core';
import { CommonService } from 'wire-frame';
import { ActivatedRoute } from '@angular/router';
import { WorkContextService } from '../../../service/admin/work-context.service';
import { storeLoginClinicContext } from '../../../utils/clinic-context.util';

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss'
})
export class DashboardComponent {
  constructor(
    private route: ActivatedRoute,
    private common: CommonService,
    private workContext: WorkContextService,
  ) {
    const res = this.common.getLoggedInUser();
    console.log(res);

    storeLoginClinicContext(res);
    this.workContext.ensureOptionsLoaded().subscribe(() => {
      const clinicId = storeLoginClinicContext(res);
      const doctorId = res?.type === 'doctor' && res?.id ? Number(res.id) : this.workContext.getDoctorId();
      if (clinicId != null && doctorId != null) {
        this.workContext.setContext(clinicId, doctorId);
      }
    });

    console.log('Clinic ID:', sessionStorage.getItem('clinic_id'));

    if (res?.type === 'doctor') {
      this.common.redirect('/admin/prescriptions');
    }
    else {
      this.common.redirect('/admin/appointment');
    }
  }
}
